import React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu } from 'ui';
import { Tag } from 'app/components/tag';
import { isDisabled } from 'app/infrastructure/data/date';
import { routeConstants } from 'app/routes/route-constants';
import { ListItemProps } from 'app/area/subscriber-groups/list/types-store';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { MergeSubscriberGroupButton } from 'app/area/subscriber-groups/shared/merge-subscriber-group/merge-subscriber-group-button';
import styles from './list-item.scss';

export const ListItem: React.FC<ListItemProps> = ({
  item, item: { id, description }, deleting, translation,
  mergeSubscriberGroup, updateMergeSubscriberGroup
}) => {

  const disabledItem = isDisabled(item.disabled);

  return <div className={styles.subscriberGroupRow}>
    <Link
      className={`${styles.container} ${deleting ? styles.disabled : ''}`}
      to={routeConstants.subscriberGroupsEditFor(item.id)}>
      <div className={styles.content}>
        <div className={styles.leftSide}>
          <div className={styles.leftSideColumn}>
            <div className={`${styles.defaultColumn} d-block`}>
              {item.description} <div className="d-inline-block">
                {deleting && <CodetableItemLoader />}
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.rightSide} ${(item.selfService && !disabledItem) ? styles.selfServiceOnly : ''} 
        ${(!item.selfService && disabledItem) ? styles.disabledOnly : ''}`}>
          {item.selfService
            ? <Tag className={item.disabled && 'me-1'}>
              {translation.self_service}
            </Tag> : null}
          {disabledItem
            ? <Tag>
              {translation.disabled}
            </Tag> : null}
        </div>
      </div>
    </Link>
    {item.id !== 0
      ? <MeatballMenu
        id={`meatball-${item.id}`}
        className={styles.meatball}>
        <li>
          <MergeSubscriberGroupButton
            id={id}
            name={description}
            mergeSubscriberGroup={mergeSubscriberGroup}
            translation={translation}
            updateMergeSubscriberGroup={updateMergeSubscriberGroup} />
        </li>
      </MeatballMenu> : null}
  </div>;
};
